import { AssessmentMode, IADPState } from "../types";
import {ActionComponent,ActionButtonRow, FrameBody,Title} from "@npd-ng/adp-benchmark";
import connected from '../assets/connected.svg';
import online from '../assets/gloab.svg';
import { actions } from "../state";
import { Content } from "../types/Content";
import { Container } from "react-bootstrap";
import { useStateContext } from "../hooks/useStateContext";
import { checkNetworkState } from "../hooks/useNetworkService";
const logPrefix = "[ADPClient][ModeSelectionView]";
export default function ModeSelectionView(){
    const { state, dispatch } = useStateContext();
    console.log(logPrefix, "session state",state.sessionState);
    const content= state.staticContent as Content;
    const modeSelectionActions: ActionComponent[] =[]; 
    const assessmentModeStaticContent =  state.staticContent?.assessmentLaunchModes;
    const modeSelectionAction = async (selectedMode: AssessmentMode)=>{
        const warning = checkNetworkState(state.sessionState.networkConnectionState,selectedMode)
        if(warning) {
            dispatch(actions.createWarningAction(warning));
            return;
        }
        dispatch(actions.createSetAssessmentModeAction(selectedMode));
        dispatch(actions.createSetViewAction("SetupCodeValidationView"));
    }
    const ncsLaunchMode:ActionComponent = {
        iconSrc : connected,
        label : assessmentModeStaticContent?.ncs.title as string,
        actionDescription : assessmentModeStaticContent?.ncs.description as string,
        action: ()=>{modeSelectionAction("ncs")}
    };
    const onlineLaunchMode:ActionComponent = {
        iconSrc : online,
        label : assessmentModeStaticContent?.online.title as string,
        actionDescription : assessmentModeStaticContent?.online.description as string,
        action: ()=>{modeSelectionAction("online")}
    } 
    state.appState.configuration?.assessmentLaunchModes?.forEach((mode)=>{
    const action: ActionComponent = mode === "ncs" ? ncsLaunchMode :  onlineLaunchMode
    modeSelectionActions.push(action);
   })
    
    return (
        <>  
           <FrameBody>
           <Container className="titleWidth">
                 <Title  content={content?.mainText}/>
            </Container>
           <ActionButtonRow actions={modeSelectionActions} />
           </FrameBody>
        </>
    )
}